import { MdOutlineDeleteOutline } from 'react-icons/md'

import { Button } from '~/components/Buttons'
import ThumbProduct from '~/components/ThumbProduct'
import i18n from '~/i18n'
import Image from '~/modules/retailMedia/components/BannersTable/TumbProduct'

// const handleOpenModal = (data: DataModalHandle) => {
//   data.handleEditModal(data)
// }

const handleDeleteBanner = (data: DataModalHandle) => {
  data.handleDeleteBanner(data)
}
export const schema: TableSchema<DataModalHandle> = {
  media: {
    title: i18n.t('rm:campaign.create.Banner.table.media.title'),
    render: rowData => (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Image url={rowData?.media_url}>
          <ThumbProduct url={rowData?.media_url} />
        </Image>
      </div>
    )
  },
  size: {
    title: i18n.t('rm:campaign.create.Banner.table.size.title'),
    render: rowData => (
      <div style={{ lineHeight: 1 }}>
        Placement size:{' '}
        <code>
          {rowData?.dimensions?.width} x {rowData?.dimensions?.height}
        </code>
        <br />
        Image size:{' '}
        <code>
          {rowData?.raw_dimensions?.width} x {rowData?.raw_dimensions?.height}
        </code>
      </div>
    ),
    className: 'order__details col__infos col__title'
  },
  // alt_text: {
  //   title: 'Texto alternativo',
  //   render: rowData => (
  //     <div style={{ maxWidth: '18rem' }}>{rowData?.alt_text}</div>
  //   )
  // },
  actions: {
    render: rowData => (
      <div style={{ textAlign: 'right' }}>
        {/* <Button
          onClick={() => handleOpenModal(rowData)}
          size="small"
          customWidth="200"
          style={{ marginRight: '2rem' }}
        >
          <FiEdit />
        </Button> */}

        <Button
          onClick={() => handleDeleteBanner(rowData)}
          template="transparentCritical"
          size="xsmall"
          iconLeft={<MdOutlineDeleteOutline />}
          text={i18n.t('rm:campaign.create.Banner.table.actions.removeBanner')}
        />
      </div>
    )
  }
}

/**
 * Per-creative destination URL (FR-022g a FR-022i) — offsite only, merged
 * into `schema` by BannerAddFormContent.tsx (not part of the base export:
 * onsite Banner reuses the same schema and has no such field). Edited on
 * the already-accepted row, not on the pre-accept FileToUpload card: upload
 * there starts automatically as soon as the file validates, which
 * unmounted that card (and any field in it) before there was a real window
 * to type a URL.
 */
export const destinationUrlColumn: TableSchemaItem<DataModalHandle> = {
  title: i18n.t('rm:campaign.create.Banner.destinationUrl.label'),
  // The fallback rule used to live in the input's placeholder, where the
  // column is too narrow to show it and placeholder grey is too faint to
  // read — so the one text that explains the rule was doing no work
  // (2026-09-15 demo, SPEC 004 item 4.3). It now lives in the column's help
  // tooltip and, for a pointer already on the field, in the input's native
  // title — leaving the placeholder itself short enough to fit.
  helpText: i18n.t('rm:campaign.create.Banner.destinationUrl.helperText'),
  render: rowData => (
    <input
      type="text"
      inputMode="url"
      className="form-control form-control-sm"
      aria-label={i18n.t('rm:campaign.create.Banner.destinationUrl.label')}
      title={i18n.t('rm:campaign.create.Banner.destinationUrl.helperText')}
      placeholder={i18n.t(
        'rm:campaign.create.Banner.destinationUrl.placeholder'
      )}
      defaultValue={rowData?.destination_url}
      onChange={event =>
        rowData?.handleUpdateDestinationUrl?.(rowData.id, event.target.value)
      }
    />
  )
}
